import ClientsSideFilter from '../../users/components/ClientsSideFilter';
import ChecklistHeader from './ChecklistHeader';
import ChecklistMain from './ChecklistScreen/ChecklistMain';

function MainPage() {
  return (
    <div className="w-full h-full min-h-0  overflow-hidden">
      <div className="w-full h-full bg-grayLightBg flex gap-1">
        <ClientsSideFilter showCopyIndicator />

        <div className="flex-1 flex flex-col gap-1 min-h-0 overflow-y-auto">
          {/* Header */}
          <ChecklistHeader />

          <ChecklistMain />
        </div>
      </div>
    </div>
  );
}

export default MainPage;
